
import Button from "@/components/base/Button"
import TextArea from "@/components/base/input/TextArea"

import dates from "@/mixins/dates"
import chatService from "@/services/chat.service"
import {
    putSchoolInternshipweek,
    getSchoolInternshipweek,
} from "@/services/v2/school.service"

export default {
    name: "InternshipWeekCreated",
    components: { Button, TextArea },
    mixins: [dates],
    props: {
        message: {
            type: Object,
            required: true,
        },
        isSelf: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            numberBusinessSites: null,
            isLoading: false,
            editedMessage: null,
            internshipWeek: null,
            body: {},
        }
    },
    computed: {
        alreadySent() {
            if (!this.internshipWeek) {
                return false
            }
            return !!this.internshipWeek.sent_at
        },
        informationMessage: {
            // separata property, for avoiding mutating given showStatisticsModal property directly
            get: function () {
                if (!this.internshipWeek) {
                    return
                }
                return `Sehr geehrte Damen und Herren, \n\nunsere Schüler sollen und wollen Praxiserfahrungen im Rahmen einer Praktikumswoche sammeln. Diese findet vom ${this.toDate(
                    this.internshipWeek.start_at
                )} bis zum ${this.toDate(
                    this.internshipWeek.ends_at
                )} statt.\n\nSollten Sie die Möglichkeit haben einem oder mehreren Schülern einen Praktikumsplatz anbieten zu können, setzen Sie sich bitte mit mir in Kontakt - gerne direkt hier im Oabat-Chat. Ich werde das Angebot direkt an die betreffenden Schüler weiterleiten.\n\nIch bedanke mich schon jetzt bei Ihnen den Fachkräften von morgen einen Einblick in Ihr Unternehmen zu gewähren.`
            },
            set: function (newMessage) {
                this.editedMessage = newMessage
            },
        },
    },
    async mounted() {
        this.body = JSON.parse(this.message.body)
        const params = this.body.params
        this.fetchSchoolInternshipWeek(params.internshipWeek.id)
    },
    methods: {
        sendInternshipWeekNotification() {
            this.isLoading = true
            let message = this.editedMessage
                ? this.editedMessage
                : this.informationMessage
            chatService
                .sendBroadcast(
                    this.internshipWeek.school?.id,
                    "SchoolBusinesses",
                    {
                        body: message,
                    }
                )
                .then(() => {
                    this.$api.run(
                        putSchoolInternshipweek,
                        this.internshipWeek.id,
                        { sent_at: new Date() }
                    )
                    this.body = ""
                    this.$store.dispatch("chat/loadConversations")
                    this.$emit("success")
                })
                .catch((error) => {
                    this.responseData = error.response.data
                    console.error(error)
                    this.$emit("error", error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        fetchSchoolInternshipWeek(id) {
            this.$api
                .run(getSchoolInternshipweek, id)
                .then(
                    (internshipWeek) => (this.internshipWeek = internshipWeek)
                )
                .catch((error) => {
                    console.error(error)
                    this.$emit("error", error)
                })
        },
    },
}
